module.exports = __webpack_public_path__ + "static/media/seal.5556e4d5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/common/img/seals/MT/seal.svg
// module id = 1028
// module chunks = 0